// Components, Layouts, Pages
import {
  CrmCommonPage,
  JobsCommonPage,
  LeadCommonPage,
  TaskCommonPage,
  UserCommonPage,
  VenueCommonPage,
  OrderCommonPage,
  QuotesCommonPage,
  TrucksCommonPage,
  ClientCommonPage,
  GlobalCommonPage,
  ReportsCommonPage,
  TrailerCommonPage,
  PackageCommonPage,
  InvoiceCommonPage,
  VendorsCommonPage,
  CouponsCommonPage,
  ScheduleCommonPage,
  SettingsCommonPage,
  CategoryCommonPage,
  UserFormCommonPage,
  VehiclesCommonPage,
  DashboardCommonPage,
  EquipmentCommonPage,
  InventoryCommonPage,
  EventTypeCommonPage,
  RoleFormCommonPage,
  VenueFormCommonPage,
  OrderFormCommonPage,
  ChecklistCommonPage,
  JobDetailCommonPage,
  QuarantineCommonPage,
  QuotesFormCommonPage,
  UserDetailCommonPage,
  ClientFormCommonPage,
  InventoriesCommonPage,
  PackageFormCommonPage,
  VenueDetailCommonPage,
  InvoiceFormCommonPage,
  ClientDetailCommonPage,
  QuotesDetailCommonPage,
  OrderDetailsCommonPage,
  PurchaseOrderCommonPage,
  InventoryFormCommonPage,
  RevenueReportCommonPage,
  DeliveryReportCommonPage,
  TaskCompletionCommonPage,
  VendorsDetailsCommonPage,
  RoleManagementCommonPage,
  InventoryDetailCommonPage,
  JobCostingReportCommonPage,
  QuarantineReportCommonPage,
  QuoteRevenueReportCommonPage,
  OrderRevenueReportCommonPage,
  CancellationReportCommonPage,
  ClientIncomeReportCommonPage,
  FeatureUtilizationCommonPage,
  ReportsForemanTaskCommonPage,
  DiscountUsageReportCommonPage,
  PurchaseOrderDetailsCommonPage,
  ReportsFinancialOrderCommonPage,
  ReportsInventoryUsageCommonPage,
  ReportsOverbookingItemCommonPage,
  ReportsMarketingRevenueCommonPage,
  GeographicRevenueReportCommonPage,
  ReportsSubrentalsReportCommonPage,
  ReportsTransactionSummaryCommonPage,
} from '~/pages/common';
// Others
import { MenuNameEnum } from '~/utils/enum/common';
import { IRouteModel } from '~/utils/interface/base';
import { foremanRoute, foremanRouteAbsolute } from '../roleRoutes/foreman';
// Styles, images, icons
import { icons } from '~/assets';

export const privateForemanRoutes: IRouteModel[] = [
  {
    index: true,
    path: foremanRoute.base,
    component: DashboardCommonPage,
    name: MenuNameEnum.DASHBOARD,
    icon: icons.menuIconDashboardUnactive,
    activeIcon: icons.menuIconDashboardActive,
  },

  // Global
  {
    path: foremanRouteAbsolute.global,
    component: GlobalCommonPage,
  },

  // CRM
  {
    path: foremanRouteAbsolute.crm,
    component: CrmCommonPage,
    name: MenuNameEnum.CRM,
    icon: icons.menuIconCrmUnactive,
    activeIcon: icons.menuIconCrmActive,
    children: [
      {
        path: foremanRouteAbsolute.leads,
        component: LeadCommonPage,
        name: MenuNameEnum.LEADS,
      },
      {
        path: foremanRouteAbsolute.clients,
        component: ClientCommonPage,
        name: MenuNameEnum.CLIENT,
      },
    ],
  },
  {
    path: foremanRouteAbsolute.createLead,
    component: ClientFormCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.crm}${foremanRoute.leads}${foremanRoute.commonDetail}${foremanRoute.commonEdit}`,
    component: ClientFormCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.crm}${foremanRoute.leads}${foremanRoute.commonDetail}`,
    component: ClientDetailCommonPage,
  },
  {
    path: foremanRouteAbsolute.createClient,
    component: ClientFormCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.crm}${foremanRoute.clients}${foremanRoute.commonDetail}${foremanRoute.commonEdit}`,
    component: ClientFormCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.crm}${foremanRoute.clients}${foremanRoute.commonDetail}`,
    component: ClientDetailCommonPage,
  },

  // Schedule
  {
    path: foremanRouteAbsolute.schedule,
    component: ScheduleCommonPage,
    name: MenuNameEnum.SCHEDULE,
    icon: icons.menuIconScheduleUnactive,
    activeIcon: icons.menuIconScheduleActive,
  },

  // Jobs
  {
    path: foremanRouteAbsolute.jobs,
    component: JobsCommonPage,
    name: MenuNameEnum.JOBS,
    icon: icons.menuIconJobsUnactive,
    activeIcon: icons.menuIconJobsActive,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.jobs}${foremanRoute.commonDetail}`,
    component: JobDetailCommonPage,
  },

  // Task
  {
    path: foremanRouteAbsolute.task,
    name: MenuNameEnum.TASKS,
    icon: icons.menuIconTaskInActive,
    activeIcon: icons.menuIconTaskActive,
    component: TaskCommonPage,
  },

  // Communication
  // {
  //   path: foremanRouteAbsolute.communication,
  //   component: CommunicationCommonPage,
  //   name: MenuNameEnum.COMMUNICATION,
  //   icon: icons.menuIconCommunicationUnactive,
  //   activeIcon: icons.menuIconCommunicationActive,
  // },

  // Quotes
  {
    path: foremanRouteAbsolute.quotes,
    component: QuotesCommonPage,
    name: MenuNameEnum.QUOTES,
    icon: icons.menuIconQuotesUnactive,
    activeIcon: icons.menuIconQuotesActive,
  },
  {
    path: foremanRouteAbsolute.createQuotes,
    component: QuotesFormCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.quotes}${foremanRoute.commonDetail}${foremanRoute.commonEdit}`,
    component: QuotesFormCommonPage,
  },

  //  Order
  {
    path: foremanRouteAbsolute.order,
    component: OrderCommonPage,
    name: MenuNameEnum.ORDER,
    icon: icons.menuIconOrderInactive,
    activeIcon: icons.menuIconOrderActive,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.order}${foremanRoute.commonDetail}`,
    component: OrderDetailsCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.order}${foremanRoute.commonDetail}${foremanRoute.commonEdit}`,
    component: OrderFormCommonPage,
  },

  // Invoice
  {
    path: foremanRouteAbsolute.invoices,
    component: InvoiceCommonPage,
    name: MenuNameEnum.INVOICE,
    icon: icons.menuIconInvoiceInactive,
    activeIcon: icons.menuIconInvoiceActive,
  },
  {
    path: foremanRouteAbsolute.createInvoice,
    component: InvoiceFormCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.invoice}${foremanRoute.commonDetail}${foremanRoute.commonEdit}`,
    component: InvoiceFormCommonPage,
  },

  // Inventories
  {
    path: `${foremanRoute.base}${foremanRoute.quotes}${foremanRoute.commonDetail}`,
    component: QuotesDetailCommonPage,
  },
  {
    path: foremanRouteAbsolute.inventories,
    component: InventoriesCommonPage,
    name: MenuNameEnum.INVENTORY,
    icon: icons.menuIconInventoryInactive,
    activeIcon: icons.menuIconInventoryActive,
    children: [
      {
        path: foremanRouteAbsolute.inventory,
        component: InventoryCommonPage,
        name: MenuNameEnum.PRODUCT,
      },
      {
        path: foremanRouteAbsolute.package,
        component: PackageCommonPage,
        name: MenuNameEnum.PACKAGE,
      },
      {
        path: foremanRouteAbsolute.quarantine,
        component: QuarantineCommonPage,
        name: MenuNameEnum.QUARANTINE,
      },
    ],
  },
  {
    path: foremanRouteAbsolute.createInventory,
    component: InventoryFormCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.inventory}${foremanRoute.product}${foremanRoute.commonDetail}`,
    component: InventoryDetailCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.inventory}${foremanRoute.product}${foremanRoute.commonDetail}${foremanRoute.commonEdit}`,
    component: InventoryFormCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.inventory}${foremanRoute.package}${foremanRoute.commonDetail}${foremanRoute.commonEdit}`,
    component: PackageFormCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.inventory}${foremanRoute.package}${foremanRoute.commonDetail}${foremanRoute.commonClone}`,
    component: PackageFormCommonPage,
  },

  // Report
  {
    path: `${foremanRoute.base}${foremanRoute.reports}`,
    component: ReportsCommonPage,
    name: MenuNameEnum.REPORTS,
    icon: icons.menuIconReportUnactive,
    activeIcon: icons.menuIconReportActive,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.overbookingItem}`,
    component: ReportsOverbookingItemCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.subrentalsReport}`,
    component: ReportsSubrentalsReportCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.clientIncomeReport}`,
    component: ClientIncomeReportCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.revenueReport}`,
    component: RevenueReportCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.geographicRevenueReport}`,
    component: GeographicRevenueReportCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.quoteRevenueReport}`,
    component: QuoteRevenueReportCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.orderRevenueReport}`,
    component: OrderRevenueReportCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.cancellationReport}`,
    component: CancellationReportCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.deliveryReport}`,
    component: DeliveryReportCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.taskCompletionReport}`,
    component: TaskCompletionCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.discountUsageReport}`,
    component: DiscountUsageReportCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.featureUtilizationReport}`,
    component: FeatureUtilizationCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.jobCostingReport}`,
    component: JobCostingReportCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.inventoryUsageReport}`,
    component: ReportsInventoryUsageCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.quarantineReport}`,
    component: QuarantineReportCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.foremanTaskReport}`,
    component: ReportsForemanTaskCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.marketingRevenueReport}`,
    component: ReportsMarketingRevenueCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.financialOrderReport}`,
    component: ReportsFinancialOrderCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.reports}${foremanRoute.transactionSummaryReport}`,
    component: ReportsTransactionSummaryCommonPage,
  },

  // Package
  {
    path: foremanRouteAbsolute.createPackage,
    component: PackageFormCommonPage,
  },

  {
    path: foremanRouteAbsolute.vehicles,
    component: VehiclesCommonPage,
    name: MenuNameEnum.VEHICLES,
    icon: icons.menuIconVehicleInactive,
    activeIcon: icons.menuIconVehicleActive,
    children: [
      {
        path: foremanRouteAbsolute.trucks,
        component: TrucksCommonPage,
        name: MenuNameEnum.TRUCKS,
        icon: icons.menuIconTruckInActive,
        activeIcon: icons.menuIconTruckActive,
      },
      {
        path: foremanRouteAbsolute.trailers,
        component: TrailerCommonPage,
        name: MenuNameEnum.TRAILERS,
        icon: icons.menuIconTrailerInActive,
        activeIcon: icons.menuIconTrailerActive,
      },
      {
        path: foremanRouteAbsolute.equipments,
        component: EquipmentCommonPage,
        name: MenuNameEnum.EQUIPMENTS,
        icon: icons.menuIconEquipmentInActive,
        activeIcon: icons.menuIconEquipmentActive,
      },
    ],
  },

  // Vendors
  {
    path: foremanRouteAbsolute.vendors,
    component: VendorsCommonPage,
    name: MenuNameEnum.VENDORS,
    icon: icons.menuIconVendorsInactive,
    activeIcon: icons.menuIconVendorsActive,
  },
  {
    path: foremanRouteAbsolute.detailVendor,
    component: VendorsDetailsCommonPage,
  },

  // Purchase Order
  {
    path: foremanRouteAbsolute.purchaseOrder,
    component: PurchaseOrderCommonPage,
    name: MenuNameEnum.PURCHASE_ORDER,
    icon: icons.menuIconPurchaseInactive,
    activeIcon: icons.menuIconPurchaseActive,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.purchaseOrder}${foremanRoute.commonDetail}`,
    component: PurchaseOrderDetailsCommonPage,
  },

  // Settings
  {
    path: foremanRouteAbsolute.settings,
    component: SettingsCommonPage,
    name: MenuNameEnum.SETTINGS,
    icon: icons.menuIconSettingUnactive,
    activeIcon: icons.menuIconSettingActive,
  },

  // User
  {
    path: foremanRouteAbsolute.users,
    component: UserCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.settings}${foremanRoute.users}${foremanRoute.commonDetail}`,
    component: UserDetailCommonPage,
  },
  {
    path: foremanRouteAbsolute.createUser,
    component: UserFormCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.settings}${foremanRoute.users}${foremanRoute.commonDetail}${foremanRoute.commonEdit}`,
    component: UserFormCommonPage,
  },

  // Venue
  {
    path: foremanRouteAbsolute.venue,
    component: VenueCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.settings}${foremanRoute.venue}${foremanRoute.commonDetail}`,
    component: VenueDetailCommonPage,
  },
  {
    path: foremanRouteAbsolute.createVenue,
    component: VenueFormCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.settings}${foremanRoute.venue}${foremanRoute.commonDetail}${foremanRoute.commonEdit}`,
    component: VenueFormCommonPage,
  },

  // Role Management
  {
    path: foremanRouteAbsolute.roleManagement,
    component: RoleManagementCommonPage,
  },
  {
    path: foremanRouteAbsolute.createRole,
    component: RoleFormCommonPage,
  },
  {
    path: `${foremanRoute.base}${foremanRoute.settings}${foremanRoute.roleManagement}${foremanRoute.commonDetail}${foremanRoute.commonEdit}`,
    component: RoleFormCommonPage,
  },

  // Coupon
  {
    path: foremanRouteAbsolute.coupon,
    component: CouponsCommonPage,
  },

  // Event Type
  {
    path: foremanRouteAbsolute.eventType,
    component: EventTypeCommonPage,
  },

  // Category
  {
    path: foremanRouteAbsolute.category,
    component: CategoryCommonPage,
  },

  // Checklist
  {
    path: foremanRouteAbsolute.checklist,
    component: ChecklistCommonPage,
  },
];
